import { render, staticRenderFns } from "./TrustRetrievePage.vue?vue&type=template&id=89d10eca&scoped=true"
import script from "./TrustRetrievePage.vue?vue&type=script&lang=js"
export * from "./TrustRetrievePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d10eca",
  null
  
)

export default component.exports